import React, { useState } from "react";
import GraphLabel3 from "./Components/GraphLabel3";
import DotsComponent from "./DotsComponent";
import DroughtCircle from "./DroughtCircle";

const SalesBreakdown = ({data}) => {
  return (
    <>
      <div className="graph">
      <DotsComponent/>
        <div className="graph_heading">
          <h1 className="Graph_title">SALES BREAKDOWN</h1>
        </div>
      </div>
      <GraphLabel3 color={["#4E6DCB", "#20BF55","#E15759"]} 
            value={['Category 1', 'Category 2','Category 3']}
          />
      <div className="bi-pie-chart">
        <DroughtCircle data={data} 
        // clicked={clicked} setClicked={setClicked}

        />
        <div className="bi-pie-chart-table">
          <h3>Category 1</h3>
          <div className="bi-table-data">
            <div className="bi-table-data-col">
              <p>Sales Percentage:</p>
              <p>31.04%</p>
            </div>
            <div className="bi-table-data-col">
              <p>Number of sales:</p>
              <p>10,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Order received:</p>
              <p>8,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Number of sales:</p>
              <p>10,000</p>
            </div>
            <div className="bi-table-data-col">
              <p>Order received:</p>
              <p>8,000</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SalesBreakdown;
